import { render, staticRenderFns } from "./DtcItemsTab.vue?vue&type=template&id=69f1c982&scoped=true&"
import script from "./DtcItemsTab.vue?vue&type=script&lang=js&"
export * from "./DtcItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./DtcItemsTab.vue?vue&type=style&index=0&id=69f1c982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1c982",
  null
  
)

export default component.exports